import { Helmet } from "react-helmet-async";
import { usePageSEO } from "../../hooks/usePageSEO";

interface Props {
  slug: string;
  fallbackTitle?: string;
}

export default function PageSEO({ slug, fallbackTitle }: Props) {
  const seo = usePageSEO(slug);

  const title = seo?.title || fallbackTitle || "Phonics Power";

  return (
    <Helmet>
      <title>{title}</title>
      {seo?.meta_tags.map((tag) =>
        tag.meta_name ? (
          <meta key={tag.meta_tag_id} name={tag.meta_name} content={tag.meta_content ?? ""} />
        ) : tag.meta_property ? (
          <meta key={tag.meta_tag_id} property={tag.meta_property} content={tag.meta_content ?? ""} />
        ) : null
      )}
    </Helmet>
  );
}
